// A file to handle Shopify-related utilities

// Create Shopify GID for a ProductVariant
export function convertIdToProductVariantGid(
  id?: string | number
): string | undefined {
  if (!id) return undefined

  const stringId = String(id)
  if (stringId.startsWith("gid://")) {
    return stringId
  }

  return `gid://shopify/ProductVariant/${stringId}`
}
